import React from 'react'
import "./switch.css"

const Switch = ({ onSwitch, setOnSwitch, setCurrentSlideTimer }) => {

    const handleChange = e => {
        if(onSwitch === true){
            setCurrentSlideTimer(onSwitch)
        }
    }

    return (
        <label className='switch'>
            <input type="checkbox"
                checked={onSwitch}
                onChange={handleChange} onClick={() => setOnSwitch(!onSwitch)}
                // defaultChecked={onSwitch} 
                />
            <span className='slider'
            />
        </label>
    )
}

export default Switch